import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ToolPanel from '../toolPanel/toolPanel';
import ToolPanelReminder from '../toolPanelReminder/toolPanelReminder';
import './footerResult.scss';

const FooterResult = ({ neverShowReminder }) => {
  const localStorageKey = 'vfHideToolPanelReminder';
  const [ localStorageRead, setLocalStorageRead ] = useState(false);
  const [ localStorageValue, setLocalStorageValue ] = useState(false);
  const [ showReminder, setShowReminder ] = useState(false);

  useEffect(() => {
    let value = false;

    if (typeof window !== "undefined") { 
      value = localStorage.getItem(localStorageKey);
    }

    const initialValue = JSON.parse(value);
    setLocalStorageRead(true);
    setLocalStorageValue(initialValue);
  }, []);

  useEffect(() => {
    if (localStorageRead && !localStorageValue) {
      setTimeout(() => {
        setShowReminder(true)
      }, 10000)
    }
  }, [localStorageRead, localStorageValue]);

  const handleReminderClose = () => {
    setShowReminder(false)
    localStorage.setItem(localStorageKey, JSON.stringify(true));
  };

  return (
    <footer className='vf-footer-result'>
      <ToolPanel />
      { showReminder && !neverShowReminder && (
        <ToolPanelReminder
          close={() => handleReminderClose()}
        />
      )}
    </footer>
  )
}

FooterResult.propTypes = {
  neverShowReminder: PropTypes.bool,
};

FooterResult.defaultProps = {
  neverShowReminder: false,
};

const mapStateToProps = ({ results }) => {
  return {
    neverShowReminder: results.neverShowReminder,
  };
};

export default connect(mapStateToProps)(FooterResult);
